import { styled } from "styled-components";

export const WebinarContainer = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  border-radius: 12px;
  border: ${({ theme }) => `1px solid ${theme.colors.default[50]}`};
`;
